import { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getCookies, setCookie } from "cookies-next";
import Image from "next/image";

// Components
import EmailSignUp from "./EmailSignup";

// Pictures
import subscribe from "../public/images/Subscribe.webp";

const title = {
  fontSize: "1.4rem",
};

const body = {
  fontSize: "1.25rem",
  paddingBottom: "1vh",
};

export default function EmailSignupPopup(props) {
  const [open, setOpen] = useState(false);
  const passedEmailValue = useRef("");
  const submitEmailFunction = useRef(null);

  const delayTimeToPopup = props.delaySeconds * 1000;

  useEffect(() => {
    setTimeout(() => {
      if (!getCookies("doNotOpenEmailModel").doNotOpenEmailModel) {
        setOpen(true);
      }
    }, delayTimeToPopup);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseNeverOpenAgain = () => {
    setCookie("doNotOpenEmailModel", true);
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <Image src={subscribe} priority={false} layout="responsive" width="600" height="400" alt="Email Signup" unoptimized />
        <DialogTitle sx={title}>Keep in Touch</DialogTitle>
        <DialogContent>
          <DialogContentText sx={body}>Sign up for our newsletter to stay up to date on all news from Search Exhaust.</DialogContentText>
          <DialogContentText sx={body}>
            By joining our email list, you enter for the opportunity to win various giftcards and prizes!
          </DialogContentText>
          <EmailSignUp
            passedEmailValue={passedEmailValue}
            submitEmailFunction={submitEmailFunction}
            page={props.page}
            handleSuccessFunction={handleCloseNeverOpenAgain}
          />
        </DialogContent>
        <DialogActions>
          <Button color="error" size="small" onClick={handleCloseNeverOpenAgain}>
            Dismiss
          </Button>
          <Button color="success" size="large" onClick={() => submitEmailFunction.current(passedEmailValue.current)}>
            Sign me up!
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
